"use client";

import { usePathname } from "next/navigation";

import Breadcrumb from "@/app/components/Breadcrumb";
import Navbar from "@/app/components/Navbar";

// На мобильном `/chat` экран занимает всю высоту, поэтому шапка сайта и
// хлебные крошки там только съедают место. Скрываем через CSS-класс, а не
// через JS-состояние: класс применяется сразу при серверном рендере, иначе
// на первом кадре мигнула бы шапка.
export default function SiteChrome() {
  const pathname = usePathname();
  const isChat = /^\/(ru|en)\/chat\/?$/.test(pathname ?? "");

  return (
    <div className={isChat ? "max-md:hidden" : undefined}>
      <Navbar />
      <Breadcrumb />
    </div>
  );
}
